import React from "react";
import styled from "styled-components";

const MoleculeImageContentInfoBoard = ({
  title = "",
  imageUrl = "",
  logo = null,
  orientation = "landscape",
  headerType = "image",
}) => {
  return (
    <Container orientation={orientation}>
      <ImageFrame>
        {imageUrl ? (
          <ContentImage src={imageUrl} alt={title || "uploaded image"} />
        ) : (
          <Placeholder>이미지 URL이 없습니다</Placeholder>
        )}
      </ImageFrame>
    </Container>
  );
};

export default MoleculeImageContentInfoBoard;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 12px;
`;

const TitleText = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111;
`;

const LogoWrapper = styled.div`
  height: 28px;
  img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }
`;

const ImageFrame = styled.div`
  flex: 1;
  width: 100%;
  background: #f7f8fa;
  border-radius: 16px;
  border: 1px solid #e6e9ef;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const ContentImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

const Placeholder = styled.div`
  color: #888;
  font-size: 16px;
`;